import axios from "./orderInstance"
import { toast } from "react-toastify"
export default async (orderId: string) => {
  try {
    const response: any = await axios.get(`/orders/${orderId}/jobs/create-lumia-job/result`)
    return response.data
  } catch (error) {
    return null
  }
}
